import { render } from "./EditorMarkdownIt.vue?vue&type=template&id=b82a5b60"
import script from "./EditorMarkdownIt.vue?vue&type=script&lang=js"
export * from "./EditorMarkdownIt.vue?vue&type=script&lang=js"

import "./EditorMarkdownIt.vue?vue&type=style&index=0&id=b82a5b60&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__